module.exports = __webpack_public_path__ + "media/images/photos/glass-57f50c345db44173ecbd6cba135ce012.jpg";